import './App.css';
import Error from './components/Error/Error';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard.js';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const App = () => {
  const isAuth = useSelector(state => state.auth.isAuth);
  return (
    <>    
     <Routes>
      <Route  path='/' element={<Navigate to='/login'/>}/>
      <Route exact path='/login' element={ !isAuth ? <Login/> : <Navigate to='/dashboard'/>}/>
      <Route exact path='/dashboard' element={ isAuth ? <Dashboard/> : <Navigate to='/login'/>}/>
      <Route path='/*' element={<Error/>}/>
     </Routes> 
     </>
  )
}

export default App;
